
import { useEffect, useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Hero from './components/Hero';
import ProductGrid from './components/ProductGrid';
import BrandStory from './components/BrandStory';
import Collection from './components/Collection';
import Footer from './components/Footer';

export default function Home() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative">
      <Navbar />
      <Hero scrollY={scrollY} />
      <ProductGrid />
      <BrandStory />
      <Collection />
      <Footer />
    </div>
  );
}
